module.exports = __webpack_public_path__ + "static/MaterialIcons-a37b0c01c0baf1888ca812cc0508f6e2.ttf";